import { sharedSchema } from "@shared-database/pgSchema";
import { User } from "@shared-database/models/user";
import {
  leoNotNullForeignID,
  leoID,
  timestampColumns,
} from "@shared-database/utils";
import { type InferInsertModel, type InferSelectModel } from "drizzle-orm";

// TermsAcceptance model.
export const TermsAcceptance = sharedSchema.table("TermsAcceptance", {
  // Mixins
  ...timestampColumns,

  // References
  ownerId: leoNotNullForeignID("ownerId").references(() => User.id, {
    onDelete: "cascade",
  }),

  // Properties
  id: leoID("id"),
});

// Types
export type TermsAcceptanceType = InferSelectModel<typeof TermsAcceptance>;
export type TermsAcceptanceInsertType = InferInsertModel<
  typeof TermsAcceptance
>;
